import React, { createContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

const SettingsProvider = ({ children }) => {
    // Replace initialSettings with your actual settings data

    const initialSettings = {
        apiUrl: '',
        apiToken: ''
    };

    const [settings, setSettings] = useState(initialSettings);

    useEffect(() => {
        // Fetch the settings JSON file
        fetch('/settings.json')
            .then((response) => response.json())
            .then((data) => {
                setSettings(data[window.location.hostname]);
            })
            .catch((error) => {
                console.error('Error fetching settings:', error);
            });
    }, []);


    return (
        <SettingsContext.Provider value={[ settings, setSettings ]}>
            {children}
        </SettingsContext.Provider>
    );
};

export { SettingsContext, SettingsProvider };
